export const postMessageGtag = (eventName: string, eventCategory: string, value?: number) => {
  const eventData: Record<string, any> = {
    event_category: eventCategory,
  };

  //null、undefined除外
  if (value != null) {
    eventData.value = value;
  }

  const message = {
    action: 'fireGtagEvent',
    eventName: eventName,
    eventData: eventData,
  };

  // 親フレームにメッセージを送信
  window.parent.postMessage(message, '*');
};
